// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Trip  {
    _originalTypeClassName = "Loom.BO.Trip";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Trip.translate = translateService;
}
this.ExpenseReports = [];
this.Attachments = [];
this.Travellers = [];
this.Approvals = [];
this.Id = null;
this.Title = null;
this.LatestArrivalTime = null;
this.EarliestDepartureTime = null;
this.Purpose = null;
this.Status = null;
this.CreatedOn = null;
this.TimezoneOffset = null;
this.StatusComments = null;
this.SpecialRequests = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Title:any;
LatestArrivalTime:any;
EarliestDepartureTime:any;
Purpose:any;
Status:any;
CreatedOn:any;
TimezoneOffset:any;
StatusComments:any;
SpecialRequests:any;
ExpenseReports:any;
Project:any;
Meeting:any;
Destination:any;
CreatedBy:any;
Attachments:any;
Travellers:any;
Approvals:any;
Beneficiary:any;
static setExpenseReports = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExpenseReports == null) $this.ExpenseReports = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExpenseReports.length > 0) {
                    Domain.Trip.removeExpenseReports($this, $this.ExpenseReports[0]);
                }

                Domain.Trip.addManyExpenseReports($this, copyItems);
            }
static addManyExpenseReports = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Trip.addExpenseReports($this, items[i]);
                }
            }
static addExpenseReports = ($this, item) => {
                if ($this.ExpenseReports == null) $this.ExpenseReports = [];
                if (item == null || $this.ExpenseReports.indexOf(item) > -1) return;
                $this.ExpenseReports.push(item);
if (item.Trip != $this) {
Domain.ExpenseReport.setTrip(item, $this);
}
}
static addRangeExpenseReports = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Trip.addExpenseReports($this, item));
            }
static removeExpenseReports = ($this, item) => {
                if ($this == null || $this.ExpenseReports == null || $this.ExpenseReports.indexOf(item) === -1) return;
                var _index = $this.ExpenseReports.indexOf(item);
                $this.ExpenseReports.splice(_index, 1);
item.Trip = null;
}
static clearExpenseReports = ($this) => { $this.ExpenseReports = null; }
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
if (oldValue != null) {
Domain.Project.removeTrips(oldValue, $this);
}
Domain.Project.addTrips(value, $this);
}
}
static setMeeting = ($this, value) => {
var oldValue = $this.Meeting;
$this.Meeting = value;
if (value != null) {
if (oldValue != null) {
Domain.Meeting.removeTrips(oldValue, $this);
}
Domain.Meeting.addTrips(value, $this);
}
}
static setDestination = ($this, value) => {
var oldValue = $this.Destination;
$this.Destination = value;
if (value != null) {
}
}
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setAttachments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Attachments == null) $this.Attachments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Attachments.length > 0) {
                    Domain.Trip.removeAttachments($this, $this.Attachments[0]);
                }

                Domain.Trip.addManyAttachments($this, copyItems);
            }
static addManyAttachments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Trip.addAttachments($this, items[i]);
                }
            }
static addAttachments = ($this, item) => {
                if ($this.Attachments == null) $this.Attachments = [];
                if (item == null || $this.Attachments.indexOf(item) > -1) return;
                $this.Attachments.push(item);
}
static addRangeAttachments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Trip.addAttachments($this, item));
            }
static removeAttachments = ($this, item) => {
                if ($this == null || $this.Attachments == null || $this.Attachments.indexOf(item) === -1) return;
                var _index = $this.Attachments.indexOf(item);
                $this.Attachments.splice(_index, 1);
}
static clearAttachments = ($this) => { $this.Attachments = null; }
static setTravellers = ($this, items) => {
                if (items == null) items = [];
                if ($this.Travellers == null) $this.Travellers = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Travellers.length > 0) {
                    Domain.Trip.removeTravellers($this, $this.Travellers[0]);
                }

                Domain.Trip.addManyTravellers($this, copyItems);
            }
static addManyTravellers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Trip.addTravellers($this, items[i]);
                }
            }
static addTravellers = ($this, item) => {
                if ($this.Travellers == null) $this.Travellers = [];
                if (item == null || $this.Travellers.indexOf(item) > -1) return;
                $this.Travellers.push(item);
}
static addRangeTravellers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Trip.addTravellers($this, item));
            }
static removeTravellers = ($this, item) => {
                if ($this == null || $this.Travellers == null || $this.Travellers.indexOf(item) === -1) return;
                var _index = $this.Travellers.indexOf(item);
                $this.Travellers.splice(_index, 1);
}
static clearTravellers = ($this) => { $this.Travellers = null; }
static setApprovals = ($this, items) => {
                if (items == null) items = [];
                if ($this.Approvals == null) $this.Approvals = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Approvals.length > 0) {
                    Domain.Trip.removeApprovals($this, $this.Approvals[0]);
                }

                Domain.Trip.addManyApprovals($this, copyItems);
            }
static addManyApprovals = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Trip.addApprovals($this, items[i]);
                }
            }
static addApprovals = ($this, item) => {
                if ($this.Approvals == null) $this.Approvals = [];
                if (item == null || $this.Approvals.indexOf(item) > -1) return;
                $this.Approvals.push(item);
if (item.Trip != $this) {
Domain.TripApproval.setTrip(item, $this);
}
}
static addRangeApprovals = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Trip.addApprovals($this, item));
            }
static removeApprovals = ($this, item) => {
                if ($this == null || $this.Approvals == null || $this.Approvals.indexOf(item) === -1) return;
                var _index = $this.Approvals.indexOf(item);
                $this.Approvals.splice(_index, 1);
item.Trip = null;
}
static clearApprovals = ($this) => { $this.Approvals = null; }
static setBeneficiary = ($this, value) => {
var oldValue = $this.Beneficiary;
$this.Beneficiary = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectParticipant.removeTrips(oldValue, $this);
}
Domain.ProjectParticipant.addTrips(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}